import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Button } from 'rsuite'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../../constants/project'
import { budgetFormat } from '../../../utils/formatterUtil'
import { cloneDeep } from 'lodash-es'
import { searchProjectBudgetSummary } from '../../../redux/actions/dashboard'
import { sessionGetItemObj } from '../../../utils/sessionHelpers'

export default function InfoMainIncomAndExpense({ requestBody }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const [chartOption, setChartOption] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [requestBody])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const request = requestBody ? requestBody : {}
      const response = await searchProjectBudgetSummary(request)
      // setSchema(response)
      setSchema(response)

      let charts = cloneDeep(chartSchema)

      charts.series[0].data = response?.chartDatas || []

      setChartOption(charts)
    } catch (e) {
      console.log('error ', e)
      // setError({})
    }
    setIsLoading(false)
  }

  return (
    <>
      {/* <div style={{ marginTop: 30 }}> */}
      {schema && (
        <Panel shaded collapsible defaultExpanded bordered style={{ marginTop: 15 }}>
          {schema.budgetApprove && (
            <>
              <Panel collapsible defaultExpanded header={schema.budgetApprove.header} bordered>
                {/* className="show-grid" */}
                {schema.budgetApprove && (
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Panel bordered>
                        {schema?.budgetApprove?.budgets.map((item, index) => {
                          return (
                            <Row style={{ fontWeight: 'bold' }} key={index}>
                              <Col xs={24} sm={10} md={10} lg={10}>
                                {item.title || ''}
                              </Col>
                              <Col xs={24} sm={10} md={10} lg={10} style={{ textAlign: 'right' }}>
                                {budgetFormat(item.value) || '0'} {item.unit || ''}
                              </Col>
                              <Col xs={24} sm={4} md={4} lg={4} style={{ textAlign: 'center' }}>
                                {item.percent ? `(${budgetFormat(item.percent)} %)` : ''}
                              </Col>
                            </Row>
                          )
                        })}

                        {schema.budgetApprove.approvedProject && (
                          <div style={{ textAlign: 'center', marginTop: 5 }}>
                            <p style={{ color: '#2ca888' }}>
                              {schema.budgetApprove.approvedProject || ''}
                            </p>
                          </div>
                        )}
                      </Panel>
                    </Col>
                  </Row>
                )}

                {chartOption && (
                  <Row style={{ marginTop: 20 }}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Panel bordered>
                        <Row style={{ fontWeight: 'bold' }}>
                          <Col xs={24} sm={24} md={24} lg={24}>
                            <ReactECharts
                              theme={CHART_THEME}
                              option={chartOption}
                              style={{ minHeight: '400px', width: '100%' }}
                              className={'react_for_echarts'}
                            />
                          </Col>
                        </Row>
                      </Panel>
                    </Col>
                  </Row>
                )}
              </Panel>
              <br />
            </>
          )}

          {schema.incomeAndExpense && (
            <>
              <Panel collapsible defaultExpanded header={schema.incomeAndExpense.header} bordered>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Panel bordered>
                      {schema.incomeAndExpense.values.map((item, index) => {
                        return (
                          <Row style={{ fontWeight: 'bold' }} key={index}>
                            <Col Col xs={24} sm={10} md={10} lg={8}>
                              {item.title || ''}
                            </Col>
                            <Col xs={24} sm={10} md={10} lg={10} style={{ textAlign: 'right' }}>
                              {budgetFormat(item.value) || '0'} {item.unit || ''}
                            </Col>
                            <Col xs={24} sm={4} md={4} lg={6} style={{ textAlign: 'center' }}>
                              {item.percent ? budgetFormat(item.percent) + '%' : ''}
                            </Col>
                          </Row>
                        )
                      })}
                    </Panel>
                  </Col>
                </Row>
              </Panel>
              <br />
            </>
          )}

          {schema.balance && (
            <>
              <Panel collapsible defaultExpanded header={schema.balance.header} bordered>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={8} style={{ textAlign: 'center' }}>
                    {/*{schema.balance.buttonTxt.summaryCash && (
                      <Button appearance="ghost" block style={{ marginTop: 3, marginBottom: 3 }}>
                        {schema.balance.buttonTxt.summaryCash}
                      </Button>
                    )}

                      {schema.balance.buttonTxt.summaryDeposit && (
                        <Button
                          appearance="ghost"
                          block
                          color="red"
                          style={{ marginTop: 3, marginBottom: 3 }}
                        >
                          {schema.balance.buttonTxt.summaryDeposit}
                        </Button>
                      )} */}
                  </Col>
                  {/* <Col xs={24} sm={12} md={16} lg={16}> */}
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <Panel bordered>
                      {schema.balance.values.map((item, index) => {
                        return (
                          <Row style={{ fontWeight: 'bold' }} key={index}>
                            <Col xs={24} sm={12} md={12} lg={14}>
                              {item.title || ''}
                            </Col>
                            <Col xs={24} sm={10} md={10} lg={8} style={{ textAlign: 'right' }}>
                              {budgetFormat(item.value) || '0'}
                            </Col>
                            <Col xs={24} sm={2} md={2} lg={2}>
                              {item.unit || ''}
                            </Col>
                          </Row>
                        )
                      })}
                    </Panel>
                  </Col>
                </Row>
              </Panel>
            </>
          )}
        </Panel>
      )}
      {/* </div> */}
    </>
  )
}

const colorPalette = ['#41b596', '#ffc184', '#53a7ed']

const chartSchema = {
  title: {
    text: '',
    subtext: '',
    left: 'center',
  },
  tooltip: {
    trigger: 'item',
  },
  legend: {
    orient: 'vertical',
    left: 'left',
  },
  series: [
    {
      name: '',
      type: 'pie',
      radius: '60%',
      data: [],
      color: colorPalette,
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  ],
}
